import { render } from "./RegistrarView.vue?vue&type=template&id=d838a76a"
import script from "./RegistrarView.vue?vue&type=script&lang=js"
export * from "./RegistrarView.vue?vue&type=script&lang=js"

import "./RegistrarView.vue?vue&type=style&index=0&id=d838a76a&lang=css"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__